export const LOAD_SESSION_DATA = 'LOAD_SESSION_DATA';
export const OPEN_DEPLOY_MODAL = 'OPEN_DEPLOY_MODAL';
export const CLOSE_DEPLOY_MODAL = 'CLOSE_DEPLOY_MODAL';
export const SET_RECAPTCHA_VALIDATION = 'SET_RECAPTCHA_VALIDATION'
